const THEMES = ['light', 'dark']
const currentTheme = () => {
    let theme = localStorage.getItem('theme') || undefined
    if(!THEMES.includes(theme)) {
        console.log('Theme reset to default: light')
        theme = 'light'
        updateTheme(theme)
    }
    return theme
}

const updateTheme = (theme) => {
    if(!THEMES.includes(theme)) {
        console.log('Theme reset to default: light')
        theme = 'light'
    }
    localStorage.setItem('theme', theme)
    document.documentElement.setAttribute('data-theme', theme)
}

export { currentTheme, updateTheme }
